module.exports = __webpack_public_path__ + "img/right2.81e5a2f1.png";